module.exports = __webpack_public_path__ + "media/images/upload-e506d62f286fc605e7e0ececf60042ce.svg";